import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AdminLayout } from '@/layouts/AdminLayout';
import { ProfilePage } from '@/pages/ProfilePage';
import { DashboardPage } from '@/pages/DashboardPage';
import { PropFirmsPage } from '@/pages/PropFirmsPage';
import { PropFirmEditorPage } from '@/pages/PropFirmEditorPage';
import { UnlistedFirmsPage } from '@/pages/UnlistedFirmsPage';
import { ExclusiveOffersPage } from '@/pages/ExclusiveOffersPage';
import { MediaLibraryPage } from '@/pages/MediaLibraryPage';
import { BlogPage } from '@/pages/BlogPage';
import { BlogEditorPage } from '@/pages/BlogEditorPage';
import { NewsPage } from '@/pages/NewsPage';
import { ReviewsPage } from '@/pages/ReviewsPage';
import { UsersPage } from '@/pages/UsersPage';
import { VerifiedPayoutsPage } from '@/pages/VerifiedPayoutsPage';
import { LoyaltyProgramPage } from '@/pages/LoyaltyProgramPage';
import { LeaderboardPage } from '@/pages/LeaderboardPage';
import { AnnouncementsPage } from '@/pages/AnnouncementsPage';
import { AdminAccountsPage } from '@/pages/AdminAccountsPage';
import { SiteSettingsPage } from '@/pages/SiteSettingsPage';
import { RedirectsPage } from '@/pages/RedirectsPage';
import '@/App.css';
import { SignupPage } from './auth/Signup';
import { LoginPage } from './auth/Login';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AuthProvider } from '@/authContext/AuthContext';
import {MfaSetup} from '@/auth/MfaSetup';
import { VerifyMfaPage } from './auth/VerifyMfaPage';
import { PropFirmViewPage } from './pages/PropFirmViewPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/mfa" element={<MfaSetup/>}/>
          <Route path="/verify-mfa" element={<VerifyMfaPage />} />

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<AdminLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="firms" element={<PropFirmsPage />} />
              <Route path="firms/new" element={<PropFirmEditorPage />} />
              <Route path="firms/:id/edit" element={<PropFirmEditorPage />} />
              <Route path="firms/:id" element={<PropFirmViewPage />} />
              <Route path="firms/unlisted" element={<UnlistedFirmsPage />} />
              <Route path="offers" element={<ExclusiveOffersPage />} />
              <Route path="media" element={<MediaLibraryPage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog/new" element={<BlogEditorPage />} />
              <Route path="blog/:id/edit" element={<BlogEditorPage />} />
              <Route path="news" element={<NewsPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="payouts" element={<VerifiedPayoutsPage />} />
              <Route path="loyalty" element={<LoyaltyProgramPage />} />
              <Route path="leaderboard" element={<LeaderboardPage />} />
              <Route path="admins" element={<AdminAccountsPage />} />
              <Route path="announcements" element={<AnnouncementsPage />} />
              <Route path="settings" element={<SiteSettingsPage />} />
              <Route path="redirects" element={<RedirectsPage />} />
            </Route>
          </Route>

          {/* Default redirects */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;